module.exports = __webpack_public_path__ + "fonts/Inter-900-cyrillic-ext60.47734ae.woff2";